function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296 296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M211,195.29l-23.94-6.82a1,1,0,0,0-1.27.69,40.12,40.12,0,0,1-13.67,19.59,40.62,40.62,0,0,1-47.47,1.64,40.17,40.17,0,0,1-15-18.59,1,1,0,0,0-1.31-.6L85,199.66a1,1,0,0,0-.6,1.29,67,67,0,0,0,25.27,31.62,67.73,67.73,0,0,0,79.11-2.74,66.92,66.92,0,0,0,23-33.3A1,1,0,0,0,211,195.29Z",
    style: {
      fill: "#ef83ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,179.11c35.35,0,64-28.45,64-63.55S183.35,52,148,52,84,80.45,84,115.56,112.65,179.11,148,179.11Zm0-98.06a34.51,34.51,0,1,1-34.74,34.51A34.62,34.62,0,0,1,148,81.05Z",
    style: {
      fill: "#ef83ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.74,115.56a34.59,34.59,0,0,1-30.35,34.22,35.31,35.31,0,0,0,4.39.28,34.51,34.51,0,1,0,0-69,35.31,35.31,0,0,0-4.39.28A34.58,34.58,0,0,1,182.74,115.56Z",
    style: {
      fill: "#463ad4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.13,201a1,1,0,0,1,.6-1.29l16.71-6c-.27-.6-.53-1.21-.77-1.82a1,1,0,0,0-1.31-.6L85,199.66a1,1,0,0,0-.6,1.29,67,67,0,0,0,25.27,31.62,67.75,67.75,0,0,0,40,11.39c.68,0,1.36-.06,2-.1a67.68,67.68,0,0,1-33.26-11.29A67,67,0,0,1,93.13,201Z",
    style: {
      fill: "#463ad4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,188.47a1,1,0,0,0-1.27.69,40.12,40.12,0,0,1-13.67,19.59A40.55,40.55,0,0,1,151.66,217a40.08,40.08,0,0,0,5.8.22,40.68,40.68,0,0,0,23.47-8.48,40.11,40.11,0,0,0,13.22-18.27Z",
    style: {
      fill: "#463ad4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,179.11l4.39-.15c-33.3-2.24-59.61-29.77-59.61-63.4a63.74,63.74,0,0,1,59.61-63.41L148,52c-35.35,0-64,28.45-64,63.56S112.65,179.11,148,179.11Z",
    style: {
      fill: "#463ad4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,195.29l-23.94-6.82a1,1,0,0,0-1.27.69,40.12,40.12,0,0,1-13.67,19.59,40.62,40.62,0,0,1-47.47,1.64,40.17,40.17,0,0,1-15-18.59,1,1,0,0,0-1.31-.6L85,199.66a1,1,0,0,0-.6,1.29,67,67,0,0,0,25.27,31.62,67.73,67.73,0,0,0,79.11-2.74,66.92,66.92,0,0,0,23-33.3A1,1,0,0,0,211,195.29Z",
    style: {
      fill: "none",
      stroke: "#120a6e",
      strokeMiterlimit: 10,
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,179.11c35.35,0,64-28.45,64-63.55S183.35,52,148,52,84,80.45,84,115.56,112.65,179.11,148,179.11Zm0-98.06a34.51,34.51,0,1,1-34.74,34.51A34.62,34.62,0,0,1,148,81.05Z",
    style: {
      fill: "none",
      stroke: "#120a6e",
      strokeMiterlimit: 10,
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ea86f9cd01d1643ae080c2225b48170.svg";
export { ForwardRef as ReactComponent };